import { render, staticRenderFns } from "./contract-info.vue?vue&type=template&id=b3188db0&scoped=true"
import script from "./contract-info.vue?vue&type=script&lang=js"
export * from "./contract-info.vue?vue&type=script&lang=js"
import style0 from "./contract-info.vue?vue&type=style&index=0&id=b3188db0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3188db0",
  null
  
)

export default component.exports